import {storage} from "./localstorage";
import {useEffect} from "react";

const updateVersion = (newVersion) => {
    if (storage("version") !== newVersion) {
        storage("version", newVersion);
        document.location = document.location;
    }
}
const post = async (method, body) => {
    const response = await fetch('https://mathem.org/stat', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            method,
            data: {...body, data: getData()},
            minutesOffset: new Date().getTimezoneOffset()
        }),
    });

    const {version} = await response.json();
    updateVersion(version);

    //console.log({version});
};
const getButton = (el) => {
    if (el.tagName.toLowerCase() === "button" || (el.id && el.tagName.toLowerCase() === "img") || (el.id && el.tagName.toLowerCase() === "a")) return el;
    if (el.parentElement) {
        return getButton(el.parentElement);
    } else {
        return {}
    }
};
const getData = () => {
    const authData = storage("authData");

    if (authData?.param?.leadId) {
        storage("leadId", authData.param.leadId);
    } else {
        if (!storage("leadId")) {
            storage("leadId", crypto.randomUUID());
        }
    }


    return {
        leadId: storage("leadId"),
        referrer: document.referrer || (storage("qrcode") && `https://mathem.org/qrcode`),
        url: document.location.href,
        width: window.innerWidth,
        height: window.innerHeight,
        language: window.navigator.language,
        platform: window.navigator.platform,
        product: window.navigator.product,
        userAgent: window.navigator.userAgent,
        vendor: window.navigator.vendor,
        orientation: window.screen.orientation.type,
        authData
    };
};
const popstateEvent = () => loaded("popstate", window.location.pathname);
const loadEvent = () => loaded("load", window.location.pathname);
const clickEvent = (e) => {
    const button = getButton(e.target);
    clicked(button.id, button.innerText?.trim());
}
const loaded = (url) => post("load", {url});
const clicked = (id, text) => post("click", {id, text});

export const statPost = (method) => post("post", {method});
export const statInfo = (info) => post("info", {info});
export const Stat = () => {
    useEffect(() => {
        const originalReplaceState = window.history.replaceState;
        const originalPushState = window.history.pushState;
        window.history.replaceState = function (...args) {
            loaded("replaceState", args[2])
            return originalReplaceState.apply(this, args);
        };
        window.history.pushState = function (...args) {
            loaded("pushState", args[2]);
            return originalPushState.apply(this, args);
        };
        window.addEventListener('popstate', popstateEvent);
        window.addEventListener("load", loadEvent);
        window.addEventListener("click", clickEvent);
        loadEvent();
        return () => {
            window.history.replaceState = null;
            window.history.pushState = null;
            window.removeEventListener('popstate', popstateEvent);
            window.removeEventListener("load", loadEvent);
            window.removeEventListener("click", clickEvent);
        }
    }, [])

    return false;
}
